import PropTypes from "prop-types"
import { connect } from "react-redux"

import { diamondGoToStep } from "areas/product/store/actions"
import { Tag } from "areas/product/wizard-options/components"
import Button from "components/ui/button"
import { jewlr_t } from "helpers/application"
import { cn } from "styles/utils"

const ProgressBar = ({ className, ...props }) => (
  <div
    className={cn(
      "left-1/8 absolute top-1/2 h-1 -translate-y-1/2 transition-[width] duration-300",
      className
    )}
    {...props}
  />
)

const Step = ({ ...props }) => (
  <Button
    className="relative block w-1/4 cursor-pointer text-center"
    {...props}
  />
)

const Circle = ({ className, selected, completed, ...props }) => (
  <div
    className={cn(
      "z-1 border-3 after:bg-primary relative mx-auto my-8 size-24 rounded-full after:absolute after:left-1/2 after:top-1/2 after:block after:size-12 after:-translate-x-1/2 after:-translate-y-1/2 after:rounded-full after:transition-opacity after:duration-300",
      completed ? "bg-primary border-primary" : "border-grey-20 bg-white",
      selected
        ? "border-primary after:opacity-100"
        : "border-grey-20 after:opacity-0",
      className
    )}
    {...props}
  />
)

const progressWidthClass = (currentStepName) => {
  switch (currentStepName) {
    case "confirm_stone":
      return "w-3/4"
    case "d_clarity":
      return "w-1/2"
    case "d_color":
      return "w-1/4"
    case "d_cut":
      return "w-0"
  }
}

const InternalProgress = ({
  currentStepIndex,
  currentStepName,
  cutIndex,
  goToStep,
  selectedClarity,
  selectedColor,
  selectedCut,
}) => {
  return (
    <div className="relative mb-24 flex">
      <ProgressBar className="bg-grey-20 w-3/4" />
      <ProgressBar
        className={`bg-primary ${progressWidthClass(currentStepName)}`}
      />
      <Step onClick={() => goToStep("d_cut", true)} selected>
        <div className="h-18">
          {currentStepIndex > cutIndex && <Tag> {selectedCut}</Tag>}
        </div>

        <Circle
          completed={selectedCut && currentStepIndex > cutIndex}
          selected
        />
        <p className="text-14">Cut</p>
      </Step>
      <Step
        onClick={() => goToStep("d_color", currentStepIndex > cutIndex + 1)}
        selected={currentStepIndex >= cutIndex + 1}
      >
        <div className="h-18">
          {currentStepIndex > cutIndex + 1 && <Tag> {selectedColor}</Tag>}
        </div>

        <Circle
          completed={selectedColor && currentStepIndex > cutIndex + 1}
          selected={currentStepIndex >= cutIndex + 1}
        />
        <p className="text-14">{jewlr_t("terms.Color")}</p>
      </Step>
      <Step
        onClick={() => goToStep("d_clarity", currentStepIndex > 4)}
        selected={currentStepIndex > cutIndex + 2}
      >
        <div className="h-18">
          {currentStepIndex > cutIndex + 2 && <Tag> {selectedClarity}</Tag>}
        </div>
        <Circle
          completed={selectedClarity && currentStepIndex > cutIndex + 2}
          selected={currentStepIndex >= cutIndex + 2}
        />
        <p className="text-14">Clarity</p>
      </Step>
      <Step
        onClick={() =>
          goToStep("confirm_stone", currentStepIndex > cutIndex + 3)
        }
        selected={currentStepIndex >= cutIndex + 3}
      >
        <div className="h-18">
          {currentStepIndex > cutIndex + 3 && <Tag> &nbsp;</Tag>}
        </div>

        <Circle selected={currentStepIndex >= cutIndex + 3} />
        <p className="text-14">Complete</p>
      </Step>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    currentStepIndex: state.diamondUI.currentStep,
    currentStepName: state.diamondUI.steps[state.diamondUI.currentStep],
    cutIndex: state.diamondUI.steps.indexOf("d_cut"),
    selectedClarity: state.diamondUI.tmpDiamond.d_clarity,
    selectedColor: state.diamondUI.tmpDiamond.d_color,
    selectedCut: state.diamondUI.tmpDiamond.d_cut,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    goToStep: (step, value) => {
      if (value) {
        dispatch(diamondGoToStep(step))
      }
    },
  }
}

InternalProgress.propTypes = {
  currentStepIndex: PropTypes.number,
  currentStepName: PropTypes.string,
  cutIndex: PropTypes.number,
  goToStep: PropTypes.func,
  selectedClarity: PropTypes.string,
  selectedColor: PropTypes.string,
  selectedCut: PropTypes.string,
}
Circle.propTypes = {
  className: PropTypes.string,
  completed: PropTypes.bool,
  selected: PropTypes.bool,
}
ProgressBar.propTypes = {
  className: PropTypes.string,
}
const Progress = connect(mapStateToProps, mapDispatchToProps)(InternalProgress)

export default Progress
